import {APPLICATION_NAMES} from '@constants/main';

export type AccountProperties = {
    country: string;
    company: string;
    accountId: string;
    subscriptionPlan: string;
}

export type SurvicateTraits = {
    email: string;
    created_at: string;
    application: typeof APPLICATION_NAMES[keyof typeof APPLICATION_NAMES];
    country: string;
    company: string;
    environment: string;
    account_id: string;
    user_role: string;
    language: string;
    subscription_plan: string;
    features: string;
}

export type ThemeMode = 'light' | 'dark' | 'auto';

/**
 * `window._sva` carries both the pre-load configuration and, once the SDK boots, its methods:
 * the bundle does `window._sva = {...window._sva, ...methods}`, so whatever is assigned before the
 * script loads survives. The methods are absent until the `SurvicateReady` event fires.
 */
export interface SurvicateInstance {
    traits?: Record<string, string | number | boolean>;
    themeMode?: ThemeMode;
    forcedLanguage?: string;
    disableTargeting?: boolean;
    hiddenSurveys?: string[];
    setVisitorTraits?: (traits: Record<string, string | number | boolean>) => void;
    setThemeMode?: (mode: ThemeMode) => void;
    setSurveyLanguage?: (languageTag: string) => void;
    retarget?: () => void;
}

export interface SurvicateWindow extends Window {
    _sva?: SurvicateInstance | undefined;
}

export const SURVICATE_READY_EVENT = 'SurvicateReady';

export const SCRIPT_IDS = {
    BEACON: 'survicate-beacon'
} as const;

export type ScriptId = typeof SCRIPT_IDS[keyof typeof SCRIPT_IDS];
